export default "__VITE_ASSET__BZMS1_CQ__"